export const log = (actionName: string, payload?: Record<string, any>) => {
  console.debug(`%c Action ${actionName} `, "background: #222; color: #bada55");
  console.debug({
    actionName,
    payload,
  });
};
